import { CommonModule } from '@angular/common';
import { AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, Component, viewChild } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { marker as _ } from '@biesbjerg/ngx-translate-extract-marker';
import { FieldType } from '@ngx-formly/core';
import { TranslatePipe } from '@ngx-translate/core';
import { simpleDeepClone } from '@phx-erp/shared';
import { ButtonModule } from 'primeng/button';
import { TooltipModule } from 'primeng/tooltip';
import { BlockableDiv } from '../../../../../shared/controls/blockable-div/blockable-div.component';
import { I18nService } from '../../../../../@core/services/i18n/i18n.service';
import { BaseDetailComponent } from '../../../../../common/base-detail.component';
import { Address, AddressPostalLink } from '../../../../../generated/generated-types';
import { FormlyFillHeightListHostDirective } from '../../../../custom-formly/formly-tabs/formly-fill-height-list-host.directive';
import { WidgetAddressPostalLinksListComponent } from '../widget-address-postal-links-list/widget-address-postal-links-list.component';

@Component({
  selector: 'app-formly-address-postal-links-list',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './formly-address-postal-links-list.component.html',
  hostDirectives: [FormlyFillHeightListHostDirective],
  standalone: true,
  imports: [
    CommonModule,
    WidgetAddressPostalLinksListComponent,
    ButtonModule,
    BlockableDiv,
    TranslatePipe,
    TooltipModule,
  ]
})
export class FormlyAddressPostalLinksListComponent extends FieldType implements AfterViewInit {

  isSaving = false;

  addressPostalLinksList = viewChild<WidgetAddressPostalLinksListComponent>('addressPostalLinksList');

  constructor(
    private cdRef: ChangeDetectorRef,
    private i18nService: I18nService
  ) {
    super();
  }

  ngAfterViewInit(): void {
    this.addressPostalLinksList()?.contextMenuItems.push({
      id: "6f42f308-c96a-40cf-baeb-8513bac80cd6",
      label: this.i18nService.translate(_("address.make-default-postal-address")),
      icon: "fa fa-star",
      command: () => {
        const selectedItem = this.addressPostalLinksList()?.contextClickItem$?.value;
        if (!selectedItem) {
          console.error("No selected item found to make default address");
          return;
        }
        const linkCopy = simpleDeepClone(selectedItem as AddressPostalLink);
        const postalAddress = linkCopy.postalAddress;
        delete postalAddress.id;

        (this.form as FormGroup).patchValue({ primaryPostalAddress: postalAddress }, { emitEvent: true });
      }
    });
    this.addressPostalLinksList()?.setContextMenuItems(this.addressPostalLinksList()?.contextMenuItems);
  }

  checkIfCanSave(): boolean {
    const component = this.options.formState.detailComponent as BaseDetailComponent<Address>;
    return component.detailForm.invalid;
  }

  async saveToUnlockEditMode(): Promise<void> {
    const component = this.options.formState.detailComponent as BaseDetailComponent<Address>;
    if (!component) {
      console.error("No detail component found to save AddressPostalLink");
      return;
    }

    this.isSaving = true;
    this.cdRef.detectChanges();

    await component.save();

    this.isSaving = false;
    this.cdRef.detectChanges();
  }
}
